import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button, List } from 'antd'
import SubPolicy from './SubPolicy'

@inject((store: any) => {
    const { popupStore } = store

    return {
        popupStore
    }
})
@observer
export default class InsuranceCaseCoversPopup extends Component<any, any> {
    state: any = {
        userInfo: {},
        errors: {}
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const {
            popupStore: { popupType, info }
        } = this.props
        const cases = {}

        return (
            <Modal
                title={
                    <div>
                        <div>פוליסות משנה עבור {info.policy_name}</div>
                        <div>מספר פוליסה לקוח: {info.policy_number}</div>
                    </div>
                }
                visible={popupType === 'insuranceSubPolicies'}
                width={800}
                onCancel={this.closePopup}
                cancelText="סגור"
            >
                <List
                    dataSource={info.policies}
                    pagination={{
                        pageSize: 8
                    }}
                    style={{ marginBottom: '3rem' }}
                    renderItem={item => (
                        <List.Item key={item['id']}>
                            <SubPolicy {...item} />
                        </List.Item>
                    )}
                />
            </Modal>
        )
    }
}
